var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('div',{staticClass:"container-sarah"},[_c('menu-footer')],1),_c('div',{staticClass:"build-number"},[_vm._v("\n    "+_vm._s(_vm.buildVer)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }